import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireAnalyticsEvent, type FireAnalyticsCallback } from '@atlaskit/editor-common/analytics';

export function useFireAnalyticsEvent(): FireAnalyticsCallback {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(() => fireAnalyticsEvent(createAnalyticsEvent), [createAnalyticsEvent]);
}
